import useTimeZoneConfiguration from 'hb-react/shared/hooks/useTimeZoneConfiguration';

const useEventDisplayTimeZone = (eventTimeZone) => {
  const timeZoneConfiguration = useTimeZoneConfiguration();

  return timeZoneConfiguration.eventDatesInUserTimezone
    ? timeZoneConfiguration.currentUserTimezone
    : eventTimeZone;
};

export default useEventDisplayTimeZone;
